<template>
  <div class="doctor-forever-reward">
    <div class="container">
      <!-- 搜索条件 -->
      <div class="doctor-forever-reward-search">
        <el-form
          ref="doctorForeverRewardFormRef"
          :inline="true"
          :model="doctorForeverRewardForm"
          class="demo-form-inline"
        >
          <el-form-item label="支付时间">
            <el-date-picker
              v-model="doctorForeverRewardForm.date"
              clearable
              type="daterange"
              value-format="yyyy-MM-dd"
              format="yyyy - MM - dd"
              unlink-panels
              range-separator="——"
              end-placeholder="结束日期"
              start-placeholder="开始日期"
              size="small"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="用户手机号">
            <el-input
              v-model="doctorForeverRewardForm.phone"
              clearable
              size="small"
            ></el-input>
          </el-form-item>

          <el-form-item label="结算状态">
            <el-select
              v-model="doctorForeverRewardForm.forever_status"
              clearable
              size="small"
            >
              <el-option
                v-for="item in foreverstatusOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="small" @click="searchBtn">
              查 询<i class="el-icon-search el-icon--right" />
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格 -->
      <div class="doctor-forever-reward-table">
        <el-table
          v-loading="tableLoading"
          :header-cell-style="{ background: '#F5F5F5' }"
          :data="doctorForeverRewardData"
          style="width: 100%"
        >
          <el-table-column
            v-for="item in tableHeader"
            :key="item.prop"
            :label="item.label"
            :prop="item.prop"
            :width="item.width"
            :fixed="item.fixed"
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'user_info'">
                <div>{{ scope.row.nick_name }}</div>
                <div>{{ scope.row.phone }}</div>
              </div>

              <div v-else-if="item.prop == 'status'">
                {{ scope.row.status | statusText }}
              </div>

              <div v-else-if="item.prop == 'pay_time'">
                {{ scope.row.pay_time | dateFormat }}
              </div>

              <div v-else>
                {{
                  JSON.stringify(scope.row[item.prop]) === "null"
                    ? ""
                    : scope.row[item.prop]
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="medium"
                @click="toDetail(scope.row)"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('375') : false
                "
                >查看详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pagination.page"
        :limit.sync="pagination.pageNumber"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination/index.vue";
import dayjs from "dayjs";
import marketing from "@/api/marketing";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      moduleName: 1,
      doctorForeverRewardForm: {
        date: [],
        user_name: "",
        phone: "",
        forever_status: "",
      },
      total: 100,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      tableHeader: [
        {
          label: "订单编号",
          prop: "order_sn",
          width: "auto",
          fixed: "left",
        },

        {
          label: "订单支付时间",
          prop: "pay_time",
          width: "auto",
          fixed: false,
        },

        {
          label: "用户信息",
          prop: "user_info",
          width: "auto",
          fixed: false,
        },
        {
          label: "订单总金额",
          prop: "order_money",
          width: "auto",
          fixed: false,
        },

        {
          label: "医生佣金",
          prop: "recommend_money",
          width: "auto",
          fixed: false,
        },
        {
          label: "订单状态",
          prop: "status_str",
          width: "auto",
          fixed: false,
        },
        {
          label: "结算状态",
          prop: "forever_status_str",
          width: "100",
          fixed: false,
        },
      ],
      foreverstatusOption: [
        {
          label: "待系统结算",
          value: 1,
        },
        {
          label: "待结算",
          value: 2,
        },
        {
          label: "已结算",
          value: 3,
        },
        {
          label: "已失效",
          value: 4,
        },
      ],
      doctorForeverRewardData: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm:ss");
    },
    statusText(val) {
      switch (val) {
        case 1:
          return "待审核";
        case 2:
          return "待发药";
        case 3:
          return "待收货";
        case 4:
          return "已完成";
        case 5:
          return "不通过";
        case 6:
          return "平台退款";
      }
    },
    sexText(val) {
      switch (val) {
        case 1:
          return "男";
        case 2:
          return "女";
        case 0:
          return "未知";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.tableLoading = true;
      let params = Object.assign(
        {},
        this.pagination,
        this.doctorForeverRewardForm,
        this.$route.query
      );
      params = _.omit(params, ["date"]);
      let times = this.doctorForeverRewardForm.date;
      params["time_start"] = times ? times[0] : "";
      params["time_end"] = times ? times[1] : "";
      marketing.getDoctorForeverRewardPatientList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.total = data.total;
          this.doctorForeverRewardData = data.list;
          this.tableLoading = false;
        }
      });
    },
    // 查询
    searchBtn() {
      this.pagination.page = 1;
      this.getList();
    },
    // 查看详情
    toDetail(row) {
      let { order_id, card_price, integral_price } = row;
      let order_type = 0;
      if (integral_price > 0) {
        order_type = 1;
      } else if (card_price > 0) {
        order_type = 2;
      } else {
        order_type = 0;
      }
      this.$router.push({
        path: "/home/shoppingmall/orderdetail",
        query: { order_id, order_type },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.doctor-forever-reward {
  .doctor-forever-reward-search {
    display: flex;
    .el-form-item {
      margin-bottom: 10px;
    }
  }
  .doctor-forever-reward-table {
    border: 1px solid #c9cdd6;
    // .el-table {
    // min-height: 476px;
    // }
  }
}
</style>
